export function validateEmail(email=""){
    return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}


export const BASE_URL = window.STAGING ? "https://api.staging.b1card.it/v1" : "https://api.b1card.it/v1"



export async function imgToBase64(img){
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(img)
        reader.onload = () => {
            resolve(reader.result)
        }
        reader.onerror = () => {reject(error)}
    })
}







